import React, { useEffect } from "react"
import { useDispatch } from "react-redux"
import { hideAlert } from "store/reducers/alertReducer"
import Swal from "sweetalert2"
import { getAppToastOptions } from "utils/toastOptions"

const SweatAlert = ({ text, type }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    showDirectToast()

    const timeout = setTimeout(() => {
      dispatch(hideAlert())
    }, 2000) // Hide alert after 3 seconds

    return () => {
      clearTimeout(timeout)
    }
  }, [dispatch])

  const showDirectToast = () => {
    const title = String(text || "").trim()
    if (!title) {
      return
    }
    Swal.fire(getAppToastOptions({ title, icon: type }))
  }
}

export default SweatAlert
